import React, { useState } from "react";
import { IconButton, Menu, MenuItem, Checkbox } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import SwapHorizontalCircleIcon from "@mui/icons-material/SwapHorizontalCircle";
import useApi from "_api/index";
import { formatCurrency2Digit } from "utils/helpers/format";

const useColumns = (
  setViewProduct,
  setProduct,
  handleViewOpen,
  handleModalOpenPrint,
  handleModalOpenReturn
) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selected, setSelected] = useState({});
  const [activeRowId, setActiveRowId] = useState(null);

  const handleMenuOpen = (event, id) => {
    setAnchorEl(event.currentTarget);
    setActiveRowId(id);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveRowId(null);
  };

  const handleCheckboxChange = (id) => {
    setSelected((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handlePrintPDF = async (id) => {
    try {
      const response = await useApi.product.getPrintPdfLendOrderOne(id);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
      window.open(url, "_blank");
    } catch (error) {
      console.error("Error printing PDF:", error);
    }
  };

  const handlePrintReturnPDF = async (id) => {
    try {
      const response = await useApi.product.getPrintPdfReturnOrder(id);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
      window.open(url, "_blank");
    } catch (error) {
      console.error("Error printing return PDF:", error);
    }
  };

  const columns = [
    {
      Header: "",
      accessor: "checkbox",
      width: "50px",
      disableSortBy: true,
      Cell: ({ row }) => (
        <Checkbox
          checked={selected[row.values.id] || false}
          onChange={() => handleCheckboxChange(row.values.id)}
        />
      ),
    },
    {
      Header: "",
      accessor: "expand",
      width: "100px",
      disableSortBy: true,
      Cell: ({ row }) =>
        row.values.actions ? (
          <IconButton onClick={() => row.toggleRowExpanded()}>
            <ExpandMoreIcon />
          </IconButton>
        ) : null,
    },
    {
      Header: "รูปภาพ",
      accessor: "picture",
      disableSortBy: true,
    },
    { Header: "รหัสรายการ", accessor: "order_code", showInFilter: false },
    {
      Header: "จำนวนประเภทสินค้า",
      accessor: "length_type",
      showInFilter: false,
    },
    {
      Header: "จำนวนสินค้าทั้งหมด",
      accessor: "lenting_amount",
      showInFilter: false,
    },
    {
      Header: "ราคารวม",
      accessor: "total_price",
      showInFilter: false,
      Cell: ({ row }) => {
        return <span>{formatCurrency2Digit(row.total_price || 0)}</span>;
      },
    },
    { Header: "ผู้ยืม", accessor: "customer_name", showInFilter: false },
    { Header: "วันที่ยืม", accessor: "created_date", showInFilter: false },
    { Header: "วันที่ต้องคืน", accessor: "return_date", showInFilter: false },
    { Header: "สถานะ", accessor: "order_status", showInFilter: false },
    {
      Header: "",
      accessor: "actions",
      disableSortBy: true,
      Cell: ({ row }) => (
        <div>
          <IconButton onClick={(event) => handleMenuOpen(event, row.id)}>
            <MoreVertIcon />
          </IconButton>
          {/* {console.log("row display", row.order_status)} */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl) && activeRowId === row.id}
            onClose={handleMenuClose}
          >
            <MenuItem
              onClick={() => {
                setViewProduct(row);
                handleViewOpen();
                handleMenuClose();
              }}
            >
              <RemoveRedEyeIcon
                style={{ marginRight: "8px", color: "#737373" }}
              />

              <span style={{ marginLeft: "8px", color: "#737373" }}>
                ดูรายละเอียด
              </span>
            </MenuItem>
            <MenuItem
              onClick={() => {
                console.log("row", row);
                // console.log("Delete product with ID:", row.original.id);
                setProduct(row);
                // handleModalOpenPrint();
                handlePrintPDF(row.id);
                handleMenuClose();
              }}
            >
              <LocalPrintshopIcon
                style={{ marginRight: "8px", color: "#737373" }}
              />
              <span style={{ marginLeft: "8px", color: "#737373" }}>
                พิมพ์ใบยืม
              </span>
            </MenuItem>
            {row && row.order_status === 6 && (
              <MenuItem
                onClick={() => {
                  console.log("row", row);
                  // console.log("Delete product with ID:", row.original.id);
                  setProduct(row);
                  // handleModalOpenPrint();
                  handlePrintReturnPDF(row.id);
                  handleMenuClose();
                }}
              >
                <LocalPrintshopIcon
                  style={{ marginRight: "8px", color: "#737373" }}
                />
                <span style={{ marginLeft: "8px", color: "#737373" }}>
                  พิมพ์ใบคืน
                </span>
              </MenuItem>
            )}
            {row && row.order_status === 5 && (
              <MenuItem
                onClick={() => {
                  // console.log("row", row);
                  setProduct(row);
                  handleModalOpenReturn();
                  handleMenuClose();
                }}
              >
                <SwapHorizontalCircleIcon
                  style={{ marginRight: "8px", color: "#737373" }}
                />
                <span style={{ marginLeft: "8px", color: "#737373" }}>
                  คืนสินค้า
                </span>
              </MenuItem>
            )}
          </Menu>
        </div>
      ),
    },
  ];

  return columns;
};

export default useColumns;
